import { createContext, ReactNode, useContext, useRef } from "react";

import { useStore } from "zustand";

import { createCaseBlocksConfigStore } from "src/cases/templates/caseBlocks/CaseBlocksConfigStore";

export type CaseBlocksConfigContextType = ReturnType<
  typeof createCaseBlocksConfigStore
>;

export const CaseBlocksConfigContext =
  createContext<CaseBlocksConfigContextType | null>(null);

type CaseBlocksConfigProviderProps = {
  children: ReactNode;
};

export const CaseBlocksConfigProvider: React.FC<
  CaseBlocksConfigProviderProps
> = ({ children }) => {
  const storeRef = useRef<CaseBlocksConfigContextType>();

  if (!storeRef.current) {
    storeRef.current = createCaseBlocksConfigStore();
  }

  return (
    <CaseBlocksConfigContext.Provider value={storeRef.current}>
      {children}
    </CaseBlocksConfigContext.Provider>
  );
};

const useCaseBlocksConfigStore = () => {
  const store = useContext(CaseBlocksConfigContext);
  if (!store) {
    throw new Error("CaseBlocksConfigContext is not defined");
  }
  return store;
};

export const useCaseBlocksConfigActions = () => {
  const store = useCaseBlocksConfigStore();
  return useStore(store, (state) => state.actions);
};

export const useSelectedBlockId = () => {
  const store = useCaseBlocksConfigStore();
  return useStore(store, (state) => state.selectedBlockId);
};
